import React from "react";

function BS4_Spinners() {
  return (
    <div>
      <h1>BS4_Spinners Component</h1>
      <p>This is the BS4_Spinners tutorial page content.</p>
    </div>
  );
}

export default BS4_Spinners;
